import { app } from '../../app.module'
// Youtubeアカウントデータのインタフェース
interface IYtAccountData {
  followers: number
  views: number
  likes: number
  dislikes: number
  comments: number
  durations: number
  posts: number
}

/**
 * Youtubeアカウントテーブルの平均
 * @class AccountYoutubeTableAverageComponentCtrl
 */
class AccountYoutubeTableAverageComponentCtrl {
  private scope: ng.IScope
  // アカウント一覧
  private sortAccounts: IYtAccountData[]
  // 1投稿あたりの平均フラグ
  private averagePerPost: boolean
  // 平均データ
  private averageData: IYtAccountData

  constructor($scope) {
    this.scope = $scope
    this.averagePerPost = true
    this.averageData = {
      followers: 0,
      views: 0,
      likes: 0,
      dislikes: 0,
      comments: 0,
      durations: 0,
      posts: 0,
    }
  }

  /**
   * アカウント一覧が変更されるまたは1投稿あたりの平均フラグが変更される時、平均を算出
   */
  public $onChanges(): void {
    this.caculateAverage()
  }

  /**
   * 平均を算出
   * @private
   * @returns {void}
   */
  private caculateAverage(): void {
    if (this.sortAccounts === undefined) {
      this.sortAccounts = []
    }
    this.averageData = {
      followers: 0,
      views: 0,
      likes: 0,
      dislikes: 0,
      comments: 0,
      durations: 0,
      posts: 0,
    }
    if (this.sortAccounts.length === 0) {
      return
    }

    // 合計する
    this.sortAccounts.forEach((account) => {
      this.averageData.followers = this.averageData.followers + account.followers
      this.averageData.posts = this.averageData.posts + account.posts
      // 1投稿あたりの平均の場合
      if (this.averagePerPost === true && account.posts > 0) {
        this.averageData.views = this.averageData.views + account.views / account.posts
        this.averageData.likes = this.averageData.likes + account.likes / account.posts
        this.averageData.dislikes = this.averageData.dislikes + account.dislikes / account.posts
        this.averageData.comments = this.averageData.comments + account.comments / account.posts
        this.averageData.durations = this.averageData.durations + account.durations / account.posts
      } else {
        // 1投稿あたりの平均ではないの場合
        this.averageData.views = this.averageData.views + account.views
        this.averageData.likes = this.averageData.likes + account.likes
        this.averageData.dislikes = this.averageData.dislikes + account.dislikes
        this.averageData.comments = this.averageData.comments + account.comments
        this.averageData.durations = this.averageData.durations + account.durations
      }
    })

    // 平均する
    const sortAccountLength = this.sortAccounts.length

    this.averageData.followers = this.averageData.followers / sortAccountLength
    this.averageData.views = this.averageData.views / sortAccountLength
    this.averageData.likes = this.averageData.likes / sortAccountLength
    this.averageData.dislikes = this.averageData.dislikes / sortAccountLength
    this.averageData.comments = this.averageData.comments / sortAccountLength
    this.averageData.durations = this.averageData.durations / sortAccountLength
    this.averageData.posts = this.averageData.posts / sortAccountLength
  }
}

app.component('accountYoutubeTableAverage', {
  bindings: {
    sortAccounts: '<',
    averagePerPost: '<',
  },
  template: require('./account-youtube-table-average.pug')(),
  controller: AccountYoutubeTableAverageComponentCtrl,
})
